export default __webpack_public_path__ + "static/media/weapp_hasxcx.6c690fcb.png";